

import React from 'react';
import { EventsWidget, QuotationsWidget, TasksWidget, MetricCard } from '../widgets';
import { TrendingUp } from 'lucide-react';
import { formatCurrency } from '@/lib/data';

interface ListsSectionProps {
  events: any[];
  quotations: any[];
  tasks: any[];
  stats: any;
  loading: boolean;
}

export function ListsSection({
  events,
  quotations,
  tasks,
  stats,
  loading,
}: ListsSectionProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
      <div className="lg:col-span-2 space-y-4 sm:space-y-6">
        <EventsWidget events={events} loading={loading} />
        <QuotationsWidget quotations={quotations} loading={loading} />
      </div>

      <div className="space-y-4 sm:space-y-6">
        <TasksWidget tasks={tasks} loading={loading} />

        <MetricCard
          title="Quick Stats"
          metrics={[
            {
              label: 'Confirmed Events',
              value: stats?.confirmed_events || 0,
            },
            {
              label: 'Avg Event Value',
              value: formatCurrency(stats?.avg_event_value || 0),
            },
            {
              label: 'Vendors Paid',
              value: stats?.vendors_paid || 0,
            },
          ]}
          icon={<TrendingUp className="w-5 h-5" />}
          status="normal"
          loading={loading}
        />
      </div>
    </div>
  );
}
